import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Spin,
  Upload,
  message,
  App,
} from "antd";
import {
  LeftOutlined,
  Loading3QuartersOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { ADD_LEARNER } from "../../apis/apis";
import { useNavigate } from "react-router-dom";
import LmsCountryDropdown from "../../components/LmsCountryDropdown";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import {
  nameRegex,
  MAX_NAME_LENGTH,
  MAX_ADDRESS_WORDS,
  getWordCount,
  PINCODE_LENGTH,
  PINCODE_REGEX,
} from "../../../helper/CommonHelper";

export default function AddLearners() {
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [address1Error, setAddress1Error] = useState("");
  const [address2Error, setAddress2Error] = useState("");
  const [pinCodeError, setPinCodeError] = useState("");
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const [image, set_image] = useState("");
  const [image_api, set_image_api] = useState("");
  const [email_send, set_email_send] = useState(false);
  const [first_name, set_first_name] = useState("");
  const [last_name, set_last_name] = useState("");
  const [organization, set_organization] = useState("");
  const [designation, set_designation] = useState("");
  const [department, set_department] = useState("");
  const [manager_name, set_manager_name] = useState("");
  const [manager_email, set_manager_email] = useState("");
  const [location, set_location] = useState("");
  const [region_location, set_region_location] = useState("");
  const [email, setEmail] = useState("");
  const [country_code, set_country_code] = useState("IN");
  const [contact_no, set_contact_no] = useState("");
  const [password, set_password] = useState("");
  const [confirm_password, set_confirm_password] = useState("");
  const [address_line_1, set_address_line1] = useState("");
  const [address_line_2, set_address_line2] = useState("");
  const [pin_code, set_pin_code] = useState("");
  const [errors, set_errors] = useState("");
  const [imageError, setimageError] = useState("");

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleChange = async (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    set_image_api(info.file);
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        set_image(url);
      });
    } else if (info.file.status === "error") {
      setLoading(false);
      message.error("Upload failed. Please try again.");
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? <Loading3QuartersOutlined /> : <PlusOutlined />}
      <div>Upload</div>
    </button>
  );

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(timer);
  }, []);

  const onFinish = async () => {
    if (firstNameError || lastNameError || address1Error || address2Error || pinCodeError) {
      message.error("Please fix validation errors before submitting");
      return;
    }

    setLoading(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("first_name", first_name);
    FORM_DATA.append("last_name", last_name);
    FORM_DATA.append("email", email);
    FORM_DATA.append("country_code", country_code);
    FORM_DATA.append("contact_no", contact_no);
    FORM_DATA.append("organization", organization);
    FORM_DATA.append("designation", designation);

    FORM_DATA.append("department", department);
    FORM_DATA.append("location", location);
    FORM_DATA.append("region_location", region_location);
    FORM_DATA.append("manager_name", manager_name);
    FORM_DATA.append("manager_email", manager_email);

    FORM_DATA.append("password", password);
    FORM_DATA.append("confirm_password", confirm_password);
    FORM_DATA.append("address_line_1", address_line_1);
    FORM_DATA.append("address_line_2", address_line_2);
    FORM_DATA.append("pin_code", pin_code);
    FORM_DATA.append("image", image_api);

    try {
      const response = await ADD_LEARNER(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });
        navigate("/learners");
      } else {
        setLoading(false);
        set_errors(response?.data?.errors);
      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error")
      );
    }
  };

  return (
    <div className="lms-body">
      <Card>
        <div className="lms-form">
          <Row>
            <Col span={12}>
              <h2>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/learners")}
                >
                  <LeftOutlined />
                </span>{" "}
                Add Learner
              </h2>
            </Col>
          </Row>

          {loading ? (
            <CulsightPageLoader />
          ) : (
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              onFinish={onFinish}
              validateTrigger="onSubmit"
            >
              <h3>Basic Information</h3>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="First Name">
                    <Input
                      value={first_name}
                      placeholder="Enter your First Name"
                      showCount={{
                        formatter: ({ count }) => `${count}/${MAX_NAME_LENGTH}`,
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        set_first_name(value);

                        if (!nameRegex.test(value)) {
                          setFirstNameError("Only alphabets and spaces are allowed");
                        } else if (value.length > MAX_NAME_LENGTH) {
                          setFirstNameError("First name cannot exceed 50 characters");
                        } else {
                          setFirstNameError("");
                        }
                      }}
                    />
                    {firstNameError && <span style={{ color: "red" }}>{firstNameError}</span>}
                    {errors?.first_name && <span style={{ color: "red" }}>{errors?.first_name}</span>}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Last Name">
                    <Input
                      value={last_name}
                      placeholder="Enter your Last Name"
                      showCount={{
                        formatter: ({ count }) => `${count}/${MAX_NAME_LENGTH}`,
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        set_last_name(value);

                        if (!nameRegex.test(value)) {
                          setLastNameError("Only alphabets and spaces are allowed");
                        } else if (value.length > MAX_NAME_LENGTH) {
                          setLastNameError(`Last name cannot exceed ${MAX_NAME_LENGTH} characters`);
                        } else {
                          setLastNameError("");
                        }
                      }}
                    />
                    {lastNameError && <span style={{ color: "red" }}>{lastNameError}</span>}
                    {errors?.last_name && <span style={{ color: "red" }}>{errors?.last_name}</span>}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Organization">
                    <Input
                      value={organization}
                      placeholder="Enter Organization"
                      onChange={(e) => set_organization(e.target.value)}
                    />
                    {errors?.organization && <span style={{ color: "red" }}>{errors?.organization}</span>}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Designation">
                    <Input
                      value={designation}
                      placeholder="Enter Designation"
                      onChange={(e) => set_designation(e.target.value)}
                    />
                    {errors?.designation && <span style={{ color: "red" }}>{errors?.designation}</span>}
                  </Form.Item>
                </Col>
              </Row>



              <h3>Contact Information</h3>

              <Form.Item label="Email">
                <Input
                  type="email"
                  value={email}
                  placeholder="Enter learner email"
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errors?.email && <span style={{ color: "red" }}>{errors?.email}</span>}
              </Form.Item>

              <Form.Item label="Contact Number">
                <LmsCountryDropdown
                  country={country_code}
                  contact={contact_no}
                  set_country_code={set_country_code}
                  set_contact_no={set_contact_no}
                />
                {errors?.contact_no && <span style={{ color: "red" }}>{errors?.contact_no}</span>}
              </Form.Item>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Address 1">
                    <Input
                      value={address_line_1}
                      placeholder="Enter your 1st address"
                      showCount={{
                        formatter: ({ count }) => `${count}/${MAX_ADDRESS_WORDS}`,
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        set_address_line1(value);

                        if (getWordCount(value) > MAX_ADDRESS_WORDS) {
                          setAddress1Error(`Address 1 cannot exceed ${MAX_ADDRESS_WORDS} characters`);
                        } else {
                          setAddress1Error("");
                        }
                      }}
                    />
                    {address1Error && <span style={{ color: "red" }}>{address1Error}</span>}
                    {errors?.address_line_1 && <span style={{ color: "red" }}>{errors?.address_line_1}</span>}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Address 2">
                    <Input
                      value={address_line_2}
                      placeholder="Enter your 2nd address"
                      showCount={{
                        formatter: ({ count }) => `${count}/${MAX_ADDRESS_WORDS}`,
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        set_address_line2(value);

                        if (getWordCount(value) > MAX_ADDRESS_WORDS) {
                          setAddress2Error(`Address 2 cannot exceed ${MAX_ADDRESS_WORDS} characters`);
                        } else {
                          setAddress2Error("");
                        }
                      }}
                    />
                    {address2Error && <span style={{ color: "red" }}>{address2Error}</span>}
                    {errors?.address_line_2 && <span style={{ color: "red" }}>{errors?.address_line_2}</span>}
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item label="Pin Code">
                <Input
                  value={pin_code}
                  placeholder="Enter your pin code"
                  showCount={{
                    formatter: ({ count }) => `${count}/${PINCODE_LENGTH}`,
                  }}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (!PINCODE_REGEX.test(value) && value !== "") {
                      setPinCodeError("Only numbers are allowed");
                      return;
                    }

                    if (value.length > PINCODE_LENGTH) {
                      setPinCodeError(`Pin code cannot exceed ${PINCODE_LENGTH} digits`);
                      return;
                    }

                    set_pin_code(value);
                    setPinCodeError("");
                  }}
                />
                {pinCodeError && <span style={{ color: "red" }}>{pinCodeError}</span>}
                {errors?.pin_code && <span style={{ color: "red" }}>{errors?.pin_code}</span>}
              </Form.Item>


              
              <h3>Organization Information</h3> 

              <Row gutter={16}>

                  <Col span={12}>
                  <Form.Item label="Manager Name">
                    <Input
                      value={manager_name}
                      placeholder="Enter Manager Name"
                      onChange={(e) => set_manager_name(e.target.value)}
                    />
                    {errors?.manager_name && <span style={{ color: "red" }}>{errors?.manager_name}</span>}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Manager Email">
                    <Input
                      value={manager_email}
                      placeholder="Enter Manager Email"
                      onChange={(e) => set_manager_email(e.target.value)}
                    />
                    {errors?.manager_email && <span style={{ color: "red" }}>{errors?.manager_email}</span>}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Department">
                    <Input
                      value={department}
                      placeholder="Enter Department"
                      onChange={(e) => set_department(e.target.value)}
                    />
                    {errors?.department && <span style={{ color: "red" }}>{errors?.department}</span>}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Location">
                    <Input
                      value={location}
                      placeholder="Enter Location"
                      onChange={(e) => set_location(e.target.value)}
                    />
                    {errors?.location && <span style={{ color: "red" }}>{errors?.location}</span>}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Region Location">
                    <Input
                      value={region_location}
                      placeholder="Enter Region Location"
                      onChange={(e) => set_region_location(e.target.value)}
                    />
                    {errors?.region_location && <span style={{ color: "red" }}>{errors?.region_location}</span>}
                  </Form.Item>
                </Col>

            
              </Row>

              <Form.Item>
                {loading ? (
                  <Button type="primary" style={{ float: "right" }}>
                    Save <Spin indicator={<LoadingOutlined spin />} size="small" />
                  </Button>
                ) : (
                  <Button type="primary" style={{ float: "right" }} htmlType="submit">
                    Save
                  </Button>
                )}
              </Form.Item>
            </Form>
          )}
        </div>
      </Card>
    </div>
  );
}
